import type { FC } from 'react';
import clsx from 'clsx';
import './style.css';

const ProgressBar: FC<{ percentageComplete: number; className?: string }> = ({
	percentageComplete,
	className = '',
}) => {
	return (
		<div
			role="progressbar"
			aria-valuenow={percentageComplete}
			aria-valuemin={0}
			aria-valuemax={100}
			className={clsx(
				'progress-bar relative w-full max-w-full h-2 rounded-full overflow-hidden mx-auto',
				className,
			)}
		>
			<div
				className="progress-bar-indicator absolute w-full h-full left-0 top-0 transform transition-transform ease-in-out duration-150 after:absolute after:inset-0 after:animate-slide overflow-hidden"
				style={{
					transform: `translateX(-${100 - percentageComplete}%)`,
				}}
			/>
		</div>
	);
};

export default ProgressBar;
